import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ScheduleAutoAssignDialogItem {
  label: string;
  value: string;
}

export interface ScheduleAutoAssignDialogData {
  gameCount: number;
  filterItems: ScheduleAutoAssignDialogItem[];
  canConfirm: boolean;
  warningMessage?: string | null;
}

@Component({
  selector: 'app-schedule-auto-assign-dialog',
  templateUrl: './schedule-auto-assign-dialog.component.html',
  styleUrls: ['./schedule-auto-assign-dialog.component.css']
})
export class ScheduleAutoAssignDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ScheduleAutoAssignDialogData,
    private dialogRef: MatDialogRef<ScheduleAutoAssignDialogComponent, boolean>
  ) {}

  close(confirmed: boolean) {
    this.dialogRef.close(confirmed);
  }
}
